import { bugsnagClient } from '@ui/lib/bugsnag';

export const TV_SAVED_DATA_NAMESPACE = 'tv-chart-state';
export const VERSION = 2; // Note: just in case for future changes

export interface SaveLoadArgs {
  symbol: string;
}

export const getKey = function (args: SaveLoadArgs): string {
  return `${TV_SAVED_DATA_NAMESPACE}.${VERSION}.${args.symbol}`;
};

export const load = function (args: SaveLoadArgs): object | undefined {
  try {
    const savedData = localStorage.getItem(getKey(args));

    if (!savedData) return;

    return JSON.parse(savedData);
  } catch (e) {
    bugsnagClient?.notify(
      new Error('Error loading TradingView state from local storage', {
        cause: e,
      }),
    );
  }
};

export const save = function (data: object, args: SaveLoadArgs) {
  try {
    localStorage.setItem(getKey(args), JSON.stringify(data));
  } catch (e) {
    bugsnagClient?.notify(
      new Error('Error saving TradingView state from local storage', {
        cause: e,
      }),
    );
  }
};
